import { ERROR_CODE, LOGIN_ERROR } from '../model/errors';

export const PolicyAction = {
  SILENT: 'silent',
  /** reject with original axios error (activation flow) */
  REJECT_RAW: 'reject_raw',
  REDIRECT_GATEWAY: 'redirect_gateway',
  SESSION: 'session',
  SHOW: 'show',
  /** special registration modal copy */
  USER_ALREADY_REGISTERED: 'user_already_registered',
  NETWORK_BANNER: 'network_banner',
};

const LOCK_INFO = '/api/v1/project/lockModule/getLockInfo';
const MANUAL_REPORT = '/api/v1/email/manualReport';
const ACTIVATION = 'getUserByActivationId';

/**
 * @param {object} input
 * @param {import('axios').AxiosError} input.error
 * @param {import('./restApiError').ApiClientError} input.apiClientError
 * @param {string} [input.baseURL] main API base URL (same host check)
 * @returns {{ action: string, redirectHref?: string }}
 */
export function resolveRestErrorPolicy({ error, apiClientError, baseURL }) {
  const cfg = error?.config || {};
  const url = cfg.url || '';
  const response = error?.response;
  const status = response?.status;
  const data = response?.data;

  if (url.includes(ACTIVATION)) {
    return { action: PolicyAction.REJECT_RAW };
  }

  if (
    cfg.url?.startsWith('http') &&
    baseURL &&
    !cfg.url.includes(baseURL) &&
    (status === ERROR_CODE.ACCESS_ERROR || status === 403)
  ) {
    return { action: PolicyAction.SILENT };
  }

  if (url.includes(LOCK_INFO) || url.includes(MANUAL_REPORT)) {
    return { action: PolicyAction.SILENT };
  }

  if (data?.status === 'USER_ALREADY_REGISTERED') {
    return { action: PolicyAction.USER_ALREADY_REGISTERED };
  }

  if (data?.error?.name === 'No Project Permissions') {
    return { action: PolicyAction.SILENT };
  }

  if (data?.error?.message === LOGIN_ERROR.ACCESS_DENIED) {
    return {
      action: PolicyAction.REDIRECT_GATEWAY,
      redirectHref: '/error?requestApp=Gateway',
    };
  }

  if (status === ERROR_CODE.ACCESS_ERROR) {
    return { action: PolicyAction.SESSION };
  }

  if (
    error.message === ERROR_CODE.NETWORK_ERROR ||
    (error?.message || '').includes('timeout')
  ) {
    return { action: PolicyAction.NETWORK_BANNER };
  }

  return { action: PolicyAction.SHOW };
}
